import { createIntl, createIntlCache } from 'react-intl';
import languages from '../../languages/languages';
import constants from '../constants';

const cache = createIntlCache();
// Check for stored language preference on initialization
const storedLanguage = window.localStorage.getItem('selectLanguage') || 'en';
const initialState = {
  intl: createIntl(
    {
      locale: storedLanguage,
      messages: languages[storedLanguage],
    },
    cache
  ),
  locale: storedLanguage,
};

export default function translationV3Reducer(state = initialState, { type, payload }) {
  switch (type) {
    case constants.SET_TRANSLATION:
      const { intl, locale } = payload;
      return { intl, locale };
    default:
      return state;
  }
}
